import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ppc_strategies = _resolveComponent("ppc-strategies");
  const _component_PPCSettingsSection = _resolveComponent("PPCSettingsSection");
  const _component_ppc_product_prioritization = _resolveComponent("ppc-product-prioritization");
  const _component_ppc_bid_settings = _resolveComponent("ppc-bid-settings");
  const _component_ppc_sb_strategies = _resolveComponent("ppc-sb-strategies");
  const _component_ppc_sb_product_prioritization = _resolveComponent("ppc-sb-product-prioritization");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ppc-page", [$props.currentTab.value]])
  }, [_ctx.ppcPageCurrentTabValue == 'settings' && $props.activateSettings && $props.currentTab.value == 'sp_budget' ? (_openBlock(), _createBlock(_component_PPCSettingsSection, {
    key: 0,
    loading: $data.dataLoadingStrategies,
    disabled: false,
    errorOccured: $data.errorOccured || $data.errorOccuredStrategies,
    onRetryOnError: _cache[0] || (_cache[0] = $event => $data.errorOccured ? $options.refreshPpcSettings : $options.refreshPpcBudgetStrategy)
  }, {
    default: _withCtx(() => [$data.initializationFinishedStrategies ? (_openBlock(), _createBlock(_component_ppc_strategies, {
      key: 0,
      onDeleteStrategy: $options.handleDeleteStrategy,
      currency: $options.currency,
      currentTab: $props.currentTab?.value
    }, null, 8, ["onDeleteStrategy", "currency", "currentTab"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading", "errorOccured"])) : _createCommentVNode("", true), _ctx.ppcPageCurrentTabValue == 'settings' && $props.activateSettings && $props.currentTab.value == 'sp_budget' ? (_openBlock(), _createBlock(_component_PPCSettingsSection, {
    key: 1,
    loading: $data.dataLoadingProductPrioritization || $data.dataLoadingBidSettings,
    disabled: false,
    errorOccured: $data.errorOccured || $data.errorOccuredProductPrioritization || $data.errorOccuredBidSettings,
    onRetryOnError: $options.refreshPpcProductPrioritization,
    title: "Latest Budget Allocation per Product",
    icon: "building",
    subtitle: `
        Review the latest budget allocation results below and adjust as needed.
        `
  }, {
    default: _withCtx(() => [_createVNode(_component_ppc_product_prioritization, {
      still_initializing: !$data.initializationFinishedProductPrioritization,
      currency: $options.currency,
      selected_profile_id: $data.selected_profile_id,
      selected_seller: $data.selected_seller
    }, null, 8, ["still_initializing", "currency", "selected_profile_id", "selected_seller"])]),
    _: 1
  }, 8, ["loading", "errorOccured", "onRetryOnError", "subtitle"])) : _createCommentVNode("", true), _ctx.ppcPageCurrentTabValue == 'settings' && $props.activateSettings && $props.currentTab.value == 'bidding' ? (_openBlock(), _createBlock(_component_PPCSettingsSection, {
    key: 2,
    loading: $data.dataLoadingBidSettings,
    disabled: false,
    errorOccured: $data.errorOccured || $data.errorOccuredBidSettings,
    onRetryOnError: $options.refreshPpcBidSettings
  }, {
    default: _withCtx(() => [$data.initializationFinishedBidSettings ? (_openBlock(), _createBlock(_component_ppc_bid_settings, {
      key: 0,
      currency: $options.currency,
      selected_seller: $data.selected_seller,
      selected_marketplace: $data.selected_marketplace,
      onGoToSBTab: _cache[1] || (_cache[1] = () => {
        _ctx.$emit('goToTab', 2);
      }),
      onGoToSPTab: _cache[2] || (_cache[2] = () => {
        _ctx.$emit('goToTab', 1);
      })
    }, null, 8, ["currency", "selected_seller", "selected_marketplace"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading", "errorOccured", "onRetryOnError"])) : _createCommentVNode("", true), _ctx.ppcPageCurrentTabValue == 'settings' && $props.activateSettings && $props.currentTab.value == 'sb_budget' ? (_openBlock(), _createBlock(_component_PPCSettingsSection, {
    key: 3,
    loading: $data.dataLoadingSbStrategies,
    disabled: false,
    errorOccured: $data.errorOccured || $data.errorOccuredSbStrategies,
    onRetryOnError: _cache[3] || (_cache[3] = $event => $data.errorOccured ? $options.refreshPpcSettings : $options.refreshPpcSbBudgetStrategy)
  }, {
    default: _withCtx(() => [$data.initializationFinishedSbStrategies ? (_openBlock(), _createBlock(_component_ppc_sb_strategies, {
      key: 0,
      onDeleteStrategy: $options.handleDeleteSbStrategy,
      currency: $options.currency,
      currentTab: $props.currentTab?.value
    }, null, 8, ["onDeleteStrategy", "currency", "currentTab"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading", "errorOccured"])) : _createCommentVNode("", true), _ctx.ppcPageCurrentTabValue == 'settings' && $props.activateSettings && $props.currentTab.value == 'sb_budget' ? (_openBlock(), _createBlock(_component_PPCSettingsSection, {
    key: 4,
    loading: $data.dataLoadingSBProductPrioritization || $data.dataLoadingBidSettings,
    disabled: false,
    errorOccured: $data.errorOccured || $data.errorOccuredSBProductPrioritization || $data.errorOccuredBidSettings,
    onRetryOnError: $options.refreshPpcSBProductPrioritization,
    title: "Latest Budget Allocation per Campaign",
    icon: "building",
    subtitle: `
        Review performance, adjust budgets and bid multipliers, and choose between AI or manual targeting and bidding.
        `
  }, {
    default: _withCtx(() => [_createVNode(_component_ppc_sb_product_prioritization, {
      still_initializing: !$data.initializationFinishedSBProductPrioritization,
      currency: $options.currency,
      selected_profile_id: $data.selected_profile_id
    }, null, 8, ["still_initializing", "currency", "selected_profile_id"])]),
    _: 1
  }, 8, ["loading", "errorOccured", "onRetryOnError", "subtitle"])) : _createCommentVNode("", true)], 2);
}